export default __webpack_public_path__ + "static/media/avatar-empty.bff7a8a8.jpeg";